import {
    SET_INFNUM,
} from '../actions/informationNumber';

export const informationNumber = (state = 0, action) => {
    switch (action.type) {
        case SET_INFNUM:
            return state=action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/informationNumber.js